var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDuties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C10.1691 0 11.2904 0.46443 12.117 1.29112C12.9437 2.11781 13.4082 3.23905 13.4082 4.40816C13.4082 5.57728 12.9437 6.69852 12.117 7.52521C11.2904 8.3519 10.1691 8.81633 9 8.81633C7.83088 8.81633 6.70965 8.3519 5.88296 7.52521C5.05627 6.69852 4.59184 5.57728 4.59184 4.40816C4.59184 3.23905 5.05627 2.11781 5.88296 1.29112C6.70965 0.46443 7.83088 0 9 0ZM9 1.92857C8.34237 1.92857 7.71168 2.18981 7.24667 2.65483C6.78165 3.11984 6.52041 3.75054 6.52041 4.40816C6.52041 5.06579 6.78165 5.69649 7.24667 6.1615C7.71168 6.62651 8.34237 6.88776 9 6.88776C9.65763 6.88776 10.2883 6.62651 10.7533 6.1615C11.2184 5.69649 11.4796 5.06579 11.4796 4.40816C11.4796 3.75054 11.2184 3.11984 10.7533 2.65483C10.2883 2.18981 9.65763 1.92857 9 1.92857Z",
    fill: "#222529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.3316C10.5097 10.3316 12.7825 10.7091 14.673 11.465C15.6182 11.8429 16.4563 12.3109 17.0551 12.8642C17.6526 13.4162 18 14.0408 18 14.7398V18H0V14.7398C0 14.0408 0.347357 13.4162 0.944888 12.8642C1.54374 12.3109 2.38181 11.8429 3.32696 11.465C5.21753 10.7091 7.49026 10.3316 9 10.3316ZM1.81378 14.7398V16.1862H16.1862V14.7398C16.1862 14.578 16.0914 14.4279 15.9778 14.3022C15.8589 14.1705 15.6917 14.0352 15.4898 13.9004C15.0851 13.6302 14.5162 13.3461 13.8459 13.0876C12.5052 12.5704 10.732 12.1454 9 12.1454C7.26805 12.1454 5.49483 12.5704 4.15409 13.0876C3.48377 13.3461 2.91495 13.6302 2.51016 13.9004C2.30831 14.0352 2.1411 14.1705 2.0222 14.3022C1.90862 14.4279 1.81378 14.578 1.81378 14.7398Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuties);
export default __webpack_public_path__ + "static/media/iconDuties.0e49577921542d4bd2f4f060ae70639e.svg";
export { ForwardRef as ReactComponent };